export enum DiscountType {
    FIXED = 1,
    PERCENTAGE = 2,
}

